import React, { useEffect, useMemo, useState } from 'react';
import { NotificationsOutlined } from '@material-ui/icons';
import { Button, Card, Col, Container, Dropdown, Row, Form, Spinner } from 'react-bootstrap';
import NotificationRequestService from 'services/notification-request';
import { Edit, DeleteForever, AddCircleOutline } from '@material-ui/icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons'
import { Link } from 'react-router-dom'
import "./style.scss";
import MyModal from 'components/MyModal';
import NewNotification from 'services/new_notification-request';
import Loading from 'components/Loading';
import Pagination from 'react-js-pagination';

function formatDate(d, with_time = false) {
  var meses = new Array("Janeiro", "Fevereiro", "Marco", "Abril", "Maio", "Junho", "Julho", "Agosto", "Septembro", "Outubro", "Novembro", "Dezembro");
  let date = d.split(" ")[0].split("T")[0];
  let [Y, M, D] = date.split("-");

  return `${D} DE ${meses[parseInt(M) - 1].toUpperCase()} DE ${Y}`;
}

function NotificationItem({ item, showModal, notificationModal, deleteConfirmationModal }) {

  const content = useMemo(() => {
    let div = document.createElement('div');
    div.innerHTML = item.content;
    let l_a = div.getElementsByTagName("a");
    let links = [];
    for (let x = 0; x < l_a.length; x++) {
      const element = l_a[x];
      links.push(element.href);
      div.removeChild(element)
    }
    return {
      content: div.innerHTML, links
    }
  }, [item])

  return (
    <div className="item-notification">
      <div className="notification-date">
        {item.date}
      </div>
      <div className="notification-title">{item.title}</div>
      <div className="notification-content">{content.content}</div>
      <ul className="notification-links">{content.links.map((link, k) => {
        return <li key={k}><a href={link}>{link}</a></li>
      })}</ul>
      {!item.disabled?
        <div className="notification-options">
          <Dropdown>
            <Dropdown.Toggle variant="primary" id="dropdown-basic">
              <div>...</div>
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Dropdown.Item onClick={() => {
                notificationModal(item)
                showModal(true)
              }}>
                <Edit /> Editar
              </Dropdown.Item>
              <Dropdown.Item onClick={() => deleteConfirmationModal(item.id)}>
                <DeleteForever /> Excluir
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      :<div className="notification-options">Desabilitada</div>}
    </div>
  );
}

export default function Notifications() {
  const defaultFilters = {
    per_page: 10,
    page: 1,
    __type: "",
    __is_admin: 1,
    __seed_to: "company",
    __with_trashed: "true",
  }
  const [filters, setFilters] = useState(defaultFilters);
  const [notifications, setNotifications] = useState([]);
  const [pagination, setPagination] = useState({})
  const [is_loading, set_is_loading] = useState(false)
  const [show_modal, set_show_modal] = useState(false)
  const [notification_modal, set_notification_modal] = useState({})
  const [delete_confirm_modal, set_delete_confirm_modal] = useState(null)
  const [showModalAddLink, setShowModalAddLink] = useState(false)
  const [_count, set_count] = useState(0)
  
  const [titleLink, setTitleLink] = useState("")
  const [hrefLink, setHrefLink] = useState("")

  useEffect(() => {
    getNotifications()
  }, [filters])

  function getNotifications() {
    set_is_loading(true)
    NewNotification.fetchAll({
      params: {...filters}
    })
    .then(res => {
      setPagination(res.data.pagination)
      setNotifications(res.data.data.map((item) => {
        return {
          id: item.id,
          priority: item.priority,
          date: formatDate(item.created_at),
          updated: formatDate(item.updated_at),
          disabled: !!item.disabled,
          title: item.title,
          content: item.content,
          type: item.type
        }
      }))
    })
    .finally(() => set_is_loading(false))

    /*NotificationRequestService.notification({
      params: {
        per_page: 10,
        is_last_messages: 1,
      }
    }).then((response) => {
      setNotifications(response.data.data.map((item) => {
        return {
          id: item.id,
          priority: item.priority,
          date: formatDate(item.created_at),
          updated: formatDate(item.updated_at),
          title: item.alert,
          content: item.title
        }
      }))
    })*/
  }

  function handleSave() {
    set_is_loading(true)
    const data = {
      id: notification_modal.id,
      priority: notification_modal.type == 2 ? 0 : notification_modal.priority,
      title: notification_modal.title,
      content: notification_modal.content,
      type: notification_modal.type,
      _method: 'put'
    }
    NewNotification.update(notification_modal.id, data)
    .then(() => {
        getNotifications()
        set_show_modal(false)
      })
      .finally(() => set_is_loading(false))

    // NotificationRequestService.save(data)
    //   .then(() => {
    //     getNotifications()
    //     set_show_modal(false)
    //   })
    //   .finally(() => set_is_loading(false))
  }

  function handleDelete(id) {
    set_is_loading(true)
    NewNotification.delete(id)
      .then(() => {
        getNotifications()
        set_delete_confirm_modal(null)
      })
      .finally(() => set_is_loading(false))

    // NotificationRequestService.delete(id)
    //   .then(() => {
    //     getNotifications()
    //     set_delete_confirm_modal(null)
    //   })
    //   .finally(() => set_is_loading(false))
  }

  const handleFilterChange = (new_filters, reset = false) => {
    let f = { ...filters, ...new_filters };
    if (reset) f = { ...defaultFilters, ...new_filters };
    setFilters(f);
  };

  const handlePageChange = (page) => handleFilterChange({ page });

  return (
    <Container>
      <Row className='mt-4 justify-content-between'>
        <Col xs="auto" className="d-flex">
          <NotificationsOutlined className="icon-title" />
          <h5 className="title-dashboard">Notificaçōes</h5>
        </Col>
        <Col xs="auto">
          <Link to="/notifications/create">
            <Button>
              <AddCircleOutline /> Adicionar notificação
            </Button>
          </Link>
        </Col>
      </Row>
      <Row>
        <Card.Body className='card-dashboard shadow bg-white rounded m-2 col-12'>
          <Row>
            <Col>
              <Row>
                <Col md="3">
                  <Form.Group>
                    <Form.Label>Itens por página:</Form.Label>
                    <Form.Control
                      as="select"
                      value={filters.per_page}
                      onChange={({ target }) => handleFilterChange({ page: 1, per_page: target.value })}
                    >
                      <option selected>10</option>
                      <option>15</option>
                      <option>25</option>
                      <option>50</option>
                    </Form.Control>
                  </Form.Group>
                </Col>
                <Col md="4">
                  <Form.Group>
                    <Form.Label>Tipo:</Form.Label>
                    <Form.Control
                      as="select"
                      value={filters.type}
                      onChange={({ target }) => handleFilterChange({ page: 1, __type: target.value })}
                    >
                      <option value="" selected>Todos</option>
                      <option value="1">Notificação</option>
                      <option value="2">Aviso</option>
                    </Form.Control>
                  </Form.Group>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row>
            <Col md="12">
              {is_loading ? (
                <Loading page />
              ) : (<>
                {notifications.map((item) => {
                  return (
                    <NotificationItem
                      key={item.id}
                      item={item}
                      showModal={set_show_modal}
                      notificationModal={set_notification_modal}
                      deleteConfirmationModal={set_delete_confirm_modal}
                    />
                  )
                })}
              </>)}
            </Col>
            <Col xs="12" md="12" className="d-flex justify-content-end">
              <Pagination
                activePage={pagination.current_page}
                itemsCountPerPage={pagination.per_page}
                totalItemsCount={pagination.total}
                pageRangeDisplayed={5}
                onChange={handlePageChange}
                itemClass="page-item"
                linkClass="page-link"
                prevPageText="‹"
                nextPageText="›"
              />
            </Col>
          </Row>
        </Card.Body>
        <MyModal
          show={delete_confirm_modal}
          onHide={() => {
            set_delete_confirm_modal(null)
          }}
          header={
            <Row>
              <Col className="card-tab-title">Deletar notificação</Col>
            </Row>
          }
          body={
            <div className='d-flex'>
              <Button
                disabled={is_loading}
                variant='success'
                onClick={() => handleDelete(delete_confirm_modal)}
                className='mr-3'
              >
                Deletar {is_loading ? <Spinner animation="border" variant="warning" size="sm" /> : <></>}
              </Button>
              <Button
                disabled={is_loading}
                variant='danger'
                onClick={() => set_delete_confirm_modal(null)}
              >
                Cancelar
              </Button>
            </div>
          }
        />
        <MyModal
          show={show_modal && ('id' in notification_modal)}
          onHide={() => {
            set_show_modal(false)
          }}
          header={
            <Row>
              <Col className="card-tab-title">Notificação</Col>
            </Row>
          }
          body={
            <Form>
              <Col md="4">
                <Form.Group>
                  <Form.Label>Tipo:</Form.Label>
                  <Form.Control
                    as="select"
                    value={notification_modal.type}
                    onChange={({ target }) => set_notification_modal({ ...notification_modal, type: target.value })}
                  >
                    <option value="" selected>Todos</option>
                    <option value="1">Notificação</option>
                    <option value="2">Aviso</option>
                  </Form.Control>
                  {/* <Select
                    placeholder="Selecione..."
                    value={notification_modal.type}
                    onChange={({ value }) => {
                      set_notification_modal({ ...notification_modal, type: value })
                    }}
                    options={[
                      { value: 1, label: 'Notificação' },
                      { value: 2, label: 'Aviso' },
                    ]}
                  /> */}
                </Form.Group>
              </Col>
              {notification_modal.type == 1 && (
                <Col md="12">
                  <Row>
                    <Col md="4">
                      <Form.Group>
                        <Form.Label>Prioridade:</Form.Label>
                        <Form.Control
                          as="select"
                          value={notification_modal.priority}
                          onChange={({ target }) => set_notification_modal({ ...notification_modal, priority: target.value })}
                        >
                          <option selected disabled>Selecione a prioridade</option>
                          <option value="0">Mais baixa</option>
                          <option value="1">Baixa</option>
                          <option value="2">Alerta</option>
                          <option value="3">Urgente</option>
                        </Form.Control>
                      </Form.Group>
                    </Col>
                  </Row>
                </Col>
              )}              
              <Col md="12">
                <Form.Group className="mb-3">
                  <Form.Label>Título:</Form.Label>
                  <Form.Control
                    type="text"
                    value={notification_modal.title}
                    onChange={({ target }) => set_notification_modal({ ...notification_modal, title: target.value })}
                  />
                </Form.Group>
              </Col>
              <Col md="12">
                <Row>
                  <Col md="12">
                    <Form.Group className="mb-3">
                      <Form.Label>
                        Mensagem: {' '}
                        <span className='ml-1 font-weight-light text-info font-italic'>
                          <FontAwesomeIcon icon={faInfoCircle} /> Caso queira adicionar um link, selecione uma palavra e pressione o botão direito do mouse.
                        </span>
                      </Form.Label>
                      <Form.Control
                        id="message-box"
                        as="textarea"
                        value={notification_modal.content}
                        onChange={({ target }) => set_notification_modal({ ...notification_modal, content: target.value })}
                        onContextMenu={(ev) => {
                          ev.preventDefault()
                          const textSelected = window.getSelection().toString().trim()
                          if (textSelected != "") {
                            setTitleLink(textSelected)
                            setShowModalAddLink(true)
                          }
                        }}
                        rows={4}
                      />
                    </Form.Group>
                  </Col>
                  <Col md="12">
                    <Form.Group>
                      <Form.Label>Preview:</Form.Label>
                      <p
                        className='form-control message-box-preview'
                        dangerouslySetInnerHTML={{ __html: notification_modal.content }}
                      />
                    </Form.Group>
                  </Col>
                </Row>
              </Col>
              <Col>
                <Button disabled={is_loading} onClick={() => handleSave()}>
                  Salvar {is_loading ? <Spinner animation="border" variant="warning" size="sm" /> : <></>}
                </Button>
              </Col>
            </Form>
          }
        />
        <MyModal
          show={showModalAddLink}
          onHide={() => {
            setShowModalAddLink(false)
          }}
          header={
            <Row>
              <Col className="card-tab-title">Notificação</Col>
            </Row>
          }
          body={
            <Form>
              <Form.Group>
                <Form.Label>Título:</Form.Label>
                <Form.Control as="input" value={titleLink} onChange={e => setTitleLink(e.target.value)} />
              </Form.Group>
              <Form.Group>
                <Form.Label>Link:</Form.Label>
                <Form.Control as="input" value={hrefLink} onChange={e => setHrefLink(e.target.value)} />
              </Form.Group>
              <Button onClick={() => {
                var link = `<a target='_blank' href='${hrefLink}'>${titleLink}</a>`
                const newMessage = notification_modal.content.replace(titleLink, link)
                set_notification_modal({ ...notification_modal, content: newMessage })
                setShowModalAddLink(false)
              }}>Adicionar</Button>
            </Form>
          }
        />
      </Row>
    </Container>
  )
}